module.exports = __webpack_public_path__ + "img/121.d45a37e1.jpg";